import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TableModule } from '@portal/shared/ui/table';
import { BundleTableTemplateComponent } from './bundle-table-template.component';

@NgModule({
  imports: [CommonModule, TableModule],
  declarations: [BundleTableTemplateComponent],
  exports: [BundleTableTemplateComponent],
})
export class BundleTableTemplateModule {}
